import debug from 'debug';

const log = debug('CloudApi');

/**
 * @deprecated use api-management instead
 */
class CloudApi {
	
	constructor() {
		this.settings = this.Settings();
	}

	static cache = [];
	static cacheIsLoading = [];

	Get(url) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'GET',
				headers: {
					'Accept': 'application/json',
					'Ocp-Apim-Subscription-Key': this.settings.cloudApiKey
				},
				credentials: 'include'
			}).then(response => {
				log('Get()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('Get() - ERROR', error);
				reject(error);
			});
		});
	}

	async getCache(key) {
		if (CloudApi.cache[key] !== undefined) return CloudApi.cache[key];
		if (CloudApi.cacheIsLoading[key]) {
			do {
				await this.sleep(50);
			} while (CloudApi.cache[key] === undefined)

			return CloudApi.cache[key];
		} else {
			CloudApi.cacheIsLoading[key] = true;
			return null;
		}
	}

	Post(url, body) {
		return new Promise((resolve, reject) => {
			fetch(url, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Ocp-Apim-Subscription-Key': this.settings.profileApiKey
				},
				credentials: 'include',
				body
			}).then(response => {
				log('Get()', url, response.status);
				resolve(response);
			}).catch(error => {
				log('Get() - ERROR', error);
				reject(error);
			});
		});
	}

	Settings() {
		let settings;

		try {
			settings = JSON.parse(document.body.getAttribute('data-cloudapi'));
			if (!settings || !settings.cloudApiKey || !settings.cloudApiUrl) {
				log('Cloud API settings is not set in BODY');
			}
		}
		catch(error) {
			log(error);
		}

		return settings;
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

}

export default CloudApi;
